import Link from "next/link";
import clsx from "clsx";
import styles from "./index.module.scss";
import Breadcrumbs from "../../common/breadcrumbs";
import Pagen from "../../common/pagen";
import News from "../../baltex/news";
import { PAGE_SIZE } from "../../../utils/newsCatalogWrapper";
import { formatDate } from "../../../utils";

export default function Articles({
  code = false,
  hideDate = false,
  isBaltex,
  isFarkop,
  isLanding,
  title,
  sections,
  section,
  news,
  size,
  currentPage,
}) {
  return (
    <div className="container">
      <Breadcrumbs />
      <h1 className={clsx(isBaltex && styles.h1Baltex)}>{title}</h1>
      <div>
        {isFarkop && (
          <ul className={styles.Sections}>
            {sections.map((section) => (
              <li
                key={section.ID}
                className={clsx(code === section.CODE && styles.Selected)}
              >
                <Link href={`/${section.CODE}`}>{section.NAME}</Link>
              </li>
            ))}
          </ul>
        )}
        {(isFarkop || isLanding) && (
          <div className={styles.NewsList}>
            {news.map((item) => (
              <Link href={`/${code}/${item.CODE}/`} key={item.CODE}>
                <a>
                  <div className={styles.Picture}>
                    <img src={item.PICTURE} alt={item.NAME} title={item.NAME} />
                  </div>
                  <div className={styles.Info}>
                    <div className={styles.Name}>{item.NAME}</div>
                    <span className={styles.Bottom}>
                      {!hideDate && `${formatDate(item.DATE)} · `}
                      {section?.NAME}
                    </span>
                  </div>
                </a>
              </Link>
            ))}
          </div>
        )}
        {isBaltex && <News items={news} isShowTitle={false} />}
        <div className={styles.Pagen}>
          <Pagen
            count={size}
            size={PAGE_SIZE}
            currentNum={currentPage}
            pagen="PAGEN_2"
          />
        </div>
      </div>
    </div>
  );
}
